import { render, staticRenderFns } from "./NewGeneralInformationForm.vue?vue&type=template&id=397fb8be&scoped=true"
import script from "./NewGeneralInformationForm.vue?vue&type=script&lang=js"
export * from "./NewGeneralInformationForm.vue?vue&type=script&lang=js"
import style0 from "./NewGeneralInformationForm.vue?vue&type=style&index=0&id=397fb8be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397fb8be",
  null
  
)

export default component.exports